import { Box, Grid } from "@mui/material";
import {
  INITIAL_PAGE_RANGE,
  Pagination,
  PaginationProps,
} from "../pagination/pagination";
import { SpaceSummaryCard } from "./SpaceSummaryCard";
import { useState } from "react";
import { PaginationRange } from "../pagination";
import { SpaceSummaryData } from "./useSpaceSummary";

export type SpaceSummaryCardListProps = {
  spaceSummaries: SpaceSummaryData[];
  PaginationProps: Omit<PaginationProps, "setPageItems">;
};

export function SpaceSummaryCardList({
  spaceSummaries,
  PaginationProps,
}: SpaceSummaryCardListProps) {
  const [pageItems, setPageItems] =
    useState<PaginationRange>(INITIAL_PAGE_RANGE);

  const paginatedSummaries = spaceSummaries.slice(pageItems.from, pageItems.to);

  return (
    <Box className="space-summary-card-list">
      <Grid container spacing={3} mb={3}>
        {paginatedSummaries.map((summary) => {
          return (
            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={summary.mrn}>
              <SpaceSummaryCard key={summary.mrn} summaryData={summary} />
            </Grid>
          );
        })}
      </Grid>
      <Pagination
        setPageItems={setPageItems}
        customPageSizes={[12, 24, 48]}
        {...PaginationProps}
      />
    </Box>
  );
}
